import axios from 'axios';
// import logger from 'helpers/logger';

export function getStrapiURL(path = '') {
  return `${process.env.NEXT_PUBLIC_STRAPI_API_URL || 'https://cms.aluguefoco.com.br'
    }${path}`;
}

export function getStrapiToken() {
  // logger.info(process.env.STRAPI_TOKEN);
  return process.env.STRAPI_TOKEN;
}

const api = axios.create({
  baseURL: getStrapiURL(),
  headers: getStrapiToken()
    ? {
      Authorization: `Bearer ${getStrapiToken()}`,
    }
    : {},
});

const isDev = process.env.PROJECT_ENV === 'rac_uat' || process.env.PROJECT_ENV === 'rac_hml';
const cfUserName = process.env.CLOUDFLARE_UAT_USERNAME || 'foco-restrito';
const cfPassword = process.env.CLOUDFLARE_UAT_PASSWORD || 'EstradaAmarela123@!';

const local = axios.create({
  baseURL: process.env.RAC_URL,
  headers:
    isDev &&
      cfUserName &&
      cfPassword
      ? {
        Authorization: `Basic ${Buffer.from(
          `${cfUserName}:${cfPassword}`,
        ).toString('base64')}`,
      }
      : {},
});

export { api, local };
